/** 表头人数与保存契约一致，不静默归零或取整。 */
export function quoteBudgetPeopleInputError(text: string): string | null {
  if (!/^\d+$/.test(text.trim())) return "请输入0～10000的整数";
  const value = Number(text);
  if (!Number.isSafeInteger(value) || value > 10000) return "人数不能超过10000";
  return null;
}
